import { render, staticRenderFns } from "./mainpage.vue?vue&type=template&id=1c75bd27"
import script from "./mainpage.vue?vue&type=script&lang=js"
export * from "./mainpage.vue?vue&type=script&lang=js"
import style0 from "./mainpage.vue?vue&type=style&index=0&id=1c75bd27&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports